import payload_plugin_qLmFnukI99 from "/opt/build/repo/node_modules/@pinia/nuxt/dist/runtime/payload-plugin.js";
import revive_payload_client_4sVQNw7RlN from "/opt/build/repo/node_modules/nuxt/dist/app/plugins/revive-payload.client.js";
import unhead_KgADcZ0jPj from "/opt/build/repo/node_modules/nuxt/dist/head/runtime/plugins/unhead.js";
import router_jmwsqit4Rs from "/opt/build/repo/node_modules/nuxt/dist/pages/runtime/plugins/router.js";
import payload_client_yVLowv6hDl from "/opt/build/repo/node_modules/nuxt/dist/app/plugins/payload.client.js";
import navigation_repaint_client_bs2bWDGRIE from "/opt/build/repo/node_modules/nuxt/dist/app/plugins/navigation-repaint.client.js";
import check_outdated_build_client_8vK7RkfGxZ from "/opt/build/repo/node_modules/nuxt/dist/app/plugins/check-outdated-build.client.js";
import chunk_reload_client_UciE0i6zes from "/opt/build/repo/node_modules/nuxt/dist/app/plugins/chunk-reload.client.js";
import plugin_vue3_YdLad5Mpq3 from "/opt/build/repo/node_modules/@pinia/nuxt/dist/runtime/plugin.vue3.js";
import components_plugin_KR1HBZs4kY from "/opt/build/repo/.nuxt/components.plugin.mjs";
import prefetch_client_5tzzN0oIVL from "/opt/build/repo/node_modules/nuxt/dist/pages/runtime/plugins/prefetch.client.js";
import plugin_tyiuIr3sFJ from "/opt/build/repo/modules/sales/src/runtime/plugin.ts";
import plugin_ghbUAjaD3n from "/opt/build/repo/node_modules/@nuxtjs/device/dist/runtime/plugin.js";
import plugin_iGLjBbor9q from "/opt/build/repo/node_modules/nuxt-jsonld/dist/runtime/plugin.js";
import plugin_adVF2uRka6 from "/opt/build/repo/node_modules/nuxt-bugsnag/dist/runtime/client/plugin.js";
import pwa_icons_plugin_LnrhIJeMG7 from "/opt/build/repo/.nuxt/pwa-icons-plugin.ts";
import pwa_client_ZuYw5i1i7i from "/opt/build/repo/node_modules/@vite-pwa/nuxt/dist/runtime/plugins/pwa.client.js";
import plugin_tbFNToZNim from "/opt/build/repo/node_modules/@zadigetvoltaire/nuxt-gtm/dist/runtime/plugin.mjs";
import plugin_PSbK9A48ZQ from "/opt/build/repo/node_modules/pinia-plugin-persistedstate/dist/nuxt/runtime/plugin.js";
import components_client_ZB1W0EeH0E from "/opt/build/repo/node_modules/nuxt-swiper/dist/runtime/plugins/components.client.js";
import plugin_WLsn00x1qh from "/opt/build/repo/node_modules/@nuxt/icon/dist/runtime/plugin.js";
import unocss_MzCDxu9LMj from "/opt/build/repo/.nuxt/unocss.mjs";
import loading_tYjkhBWuWf from "/opt/build/repo/layers/ui/plugins/loading.ts";
import vee_validate_Dfac7c9cvC from "/opt/build/repo/layers/ui/plugins/vee-validate.ts";
import index_JcX2pf9efO from "/opt/build/repo/plugins/apollo/index.ts";
import packages_340RWGHlC8 from "/opt/build/repo/plugins/packages.ts";
import posthog_ulvgx15Dgc from "/opt/build/repo/plugins/posthog.ts";
import vuetify_7h9QAQEssH from "/opt/build/repo/plugins/vuetify.ts";
export default [
  payload_plugin_qLmFnukI99,
  revive_payload_client_4sVQNw7RlN,
  unhead_KgADcZ0jPj,
  router_jmwsqit4Rs,
  payload_client_yVLowv6hDl,
  navigation_repaint_client_bs2bWDGRIE,
  check_outdated_build_client_8vK7RkfGxZ,
  chunk_reload_client_UciE0i6zes,
  plugin_vue3_YdLad5Mpq3,
  components_plugin_KR1HBZs4kY,
  prefetch_client_5tzzN0oIVL,
  plugin_tyiuIr3sFJ,
  plugin_ghbUAjaD3n,
  plugin_iGLjBbor9q,
  plugin_adVF2uRka6,
  pwa_icons_plugin_LnrhIJeMG7,
  pwa_client_ZuYw5i1i7i,
  plugin_tbFNToZNim,
  plugin_PSbK9A48ZQ,
  components_client_ZB1W0EeH0E,
  plugin_WLsn00x1qh,
  unocss_MzCDxu9LMj,
  loading_tYjkhBWuWf,
  vee_validate_Dfac7c9cvC,
  index_JcX2pf9efO,
  packages_340RWGHlC8,
  posthog_ulvgx15Dgc,
  vuetify_7h9QAQEssH
]